import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PACKAGE_NAME } from '../constants';
import { RootState } from '../types';

const initialState: { [sku: string]: number } = {};

const slice = createSlice({
    name: `${PACKAGE_NAME}/skusSelected`,
    initialState,
    reducers: {
        incrementSkuSelectedQuantity: (state, {payload}: PayloadAction<string>) => {
            state[payload] = (state[payload] || 0) + 1;
        },

        decrementSkuSelectedQuantity: (state, {payload}: PayloadAction<string>) => {
            state[payload] = Math.max((state[payload] || 0) - 1, 0);
            if (!state[payload]) {
                delete state[payload];
            }
        },

        setSkuSelectedQuantity: {
            reducer: (state, {payload}: PayloadAction<{
                sku: string;
                quantity: number;
            }>) => {
                if (!payload.sku) {
                    return;
                }
                state[payload.sku] = Math.max(+payload.quantity, 0);
                if (!state[payload.sku]) {
                    delete state[payload.sku];
                }
            },
            prepare: (sku: string, quantity: number) => {
                return { payload: { sku, quantity } }
            }
        },

        clearSkusSelected: () => ({})
    },
});

export default slice.reducer;
export const { name } = slice;
export const {
    incrementSkuSelectedQuantity,
    decrementSkuSelectedQuantity,
    setSkuSelectedQuantity,
    clearSkusSelected,
} = slice.actions;

export const selectSkusSelectedQuantities = (
    state: RootState
): Readonly<typeof initialState> => state[slice.name];

export const selectOneSkuSelectedQuantity = (sku: string) =>
    (state: RootState) => state[slice.name][sku] || 0;
